import { search } from '../../assets/js/api.js';
import * as Helpers from "@/helpers/index.js"
import axios from 'axios';

export default {
  //namespaced: true,
  state: {
    fieldsAbsSite: [],
    fieldsRelSite: [],
    itemsSite: [],
    loadingSite: false,
    uniSizeSite: '',
    resultCountSite: '',
    panelDaySite: '',
    showToastErrorSite: false,
    cancelTokenSource: null,
  },
  getters: {
    fieldsAbsSite: (state) => state.fieldsAbsSite,
    fieldsRelSite: (state) => state.fieldsRelSite,
    itemsSite: (state) => state.itemsSite,
    loadingSite: (state) => state.loadingSite,
    uniSizeSite: (state) => state.uniSizeSite,
    resultCountSite: (state) => state.resultCountSite,
    panelDaySite: (state) => state.panelDaySite,
  },
  mutations: {
    setFieldsAbsSite: (state, payload) => state.fieldsAbsSite = payload,
    setFieldsRelSite: (state, payload) => state.fieldsRelSite = payload,
    setItemsSite: (state, payload) => state.itemsSite = payload,
    setLoadingSite: (state, payload) => state.loadingSite = payload,
    setUniSizeSite: (state, payload) => state.uniSizeSite = payload,
    setResultCountSite: (state, payload) => state.resultCountSite = payload,
    setPanelDaySite: (state, payload) => state.panelDaySite = payload,
    setShowToastErrorSite: (state, payload) => state.showToastErrorSite = payload,
    setSiteState: (state, payload) => Object.assign(state, payload),
    setCancelTokenSource: (state, source) => state.cancelTokenSource = source,
  },
  actions: {
    resetReachSiteState: (context) => {
      context.commit('setSiteState', {
        fieldsAbsSite: [],
        fieldsRelSite: [],
        itemsSite: [],
        loadingSite: false,
        uniSizeSite: '',
        resultCountSite: '',
        panelDaySite: '',
        showToastErrorSite: false,
      });
      if (context.state.cancelTokenSource) {
        context.state.cancelTokenSource.cancel('Resetting site state');
        context.commit('setCancelTokenSource', null);
      }
    },
    siteSearchReach: (context) => {
      if (context.state.cancelTokenSource) {
        context.state.cancelTokenSource.cancel('New request initiated');
      }
      const cancelToken = axios.CancelToken.source();
      context.commit('setCancelTokenSource', cancelToken);

      context.commit('setItemsSite', []);
      context.commit('setFieldsAbsSite', []);
      context.commit('setFieldsRelSite', []);

      let siteReachApiBody = context.getters['siteReachApiBody/siteReachApiBody'];
      let reachSelected = false
      const measuresSite = localStorage.getItem('measuresSite') || [];
      if(measuresSite.length > 0)
      {
        let reachMeasures = JSON.parse(measuresSite).filter(measure => measure.isReach)
        if(reachMeasures.length > 0){
          let reachMeasurePayload = reachMeasures.map(m => {
            return { measure_name: m.measure_name, min_viewing_time: siteReachApiBody.reachCriteria, target_group_keys: m.target_group_keys };
          })
          context.commit('siteReachApiBody/updateMeasures', reachMeasurePayload);
          reachSelected = true
        }
      }
      if (!reachSelected) {
        return;
      }
      context.commit('setLoadingSite', true);

      // eslint-disable-next-line no-console
      search('QueryReachSiteData', { payload: siteReachApiBody }, cancelToken.token)
        .then((response) => {
          if (response.statusCode) {
            context.commit('setShowToastErrorSite', true);
          }
          context.commit('setItemsSite', []);
          context.commit('setFieldsAbsSite', []);
          context.commit('setFieldsRelSite', []);
          if (response.data && response.info) {
            context.commit('setUniSizeSite', Helpers.formatNumberWithThousandSeparator(response.info.total_universe_size));
            context.commit('setResultCountSite', Helpers.formatNumberWithThousandSeparator(response.info.total_row_count));
            context.commit('setPanelDaySite', response.info.panel_day.substring(0, 10));

            response.data.forEach((element) => {
              if (element.date_key != null) {
                element.date_key = element.date_key.substring(0, 10);
                element.date_key_rel = element.date_key.substring(0, 10);
              }
            });

            let firstField = { key: 'date_key', label: '', thClass: 'firstThRofClass' };
            let firstFieldRel = { key: 'date_key_rel', label: '', thClass: 'firstThRofClass' };
            let updatedFieldsAbs = [...context.getters.fieldsAbsSite, firstField];
            context.commit('setFieldsAbsSite', updatedFieldsAbs);
            let updatedFieldsRel = [...context.getters.fieldsRelSite, firstFieldRel];
            context.commit('setFieldsRelSite', updatedFieldsRel);

            let totalReach = { date_key: 'Net Reach 1+ indv', date_key_rel: 'Net Reach 1+ %' };
            let bigScreenReach = { date_key: 'TV-skärm Reach', date_key_rel: 'TV-skärm Reach' };
            let digitalDevicesReach = { date_key: 'Digitala enheter Reach', date_key_rel: 'Digitala enheter Reach' };
            let averageFreq = { date_key: 'Avg Freq', date_key_rel: 'Avg Freq' };
            let universeSize = {
              date_key: 'Universe size indv',
              date_key_rel: 'Universe size indv',
            };
            let emptyRow = { date_key: '' };

            let siteSelectedReachObj = { ...context.getters['siteReachForm/getSelectedReachObj'] };
            let selectedReachCriteriaText = siteSelectedReachObj.options.filter(function (
              reachCriteria,
            ) {
              if (reachCriteria.value === this) return reachCriteria;
            },
              siteSelectedReachObj.selected)[0].selectedReachCriteriaText;
            for (let i = 0; i < response.summary.length; i++) {
              let reachMeasure = JSON.parse(localStorage.measuresSite).filter((m) => m.isReach)[i];
              let field = {
                key: response.summary[i].measure,
                label: `${reachMeasure.reachAbsHeader} ${reachMeasure.ageGroup}, ${selectedReachCriteriaText}`,
              };
              updatedFieldsAbs = [...context.getters.fieldsAbsSite, field];
              context.commit('setFieldsAbsSite', updatedFieldsAbs);
              let fieldRel = {
                key: response.summary[i].measure + '_rel',
                label: `${reachMeasure.reachRelHeader} ${reachMeasure.ageGroup}, ${selectedReachCriteriaText}`,
              };
              updatedFieldsRel = [...context.getters.fieldsRelSite, fieldRel];
              context.commit('setFieldsRelSite', updatedFieldsRel);
              let universeSizeValue = response.summary[i].universe_size;
              universeSize[response.summary[i].measure] = Helpers.formatNumberWithThousandSeparator(universeSizeValue).toString().replace('.', ',');
              universeSize[response.summary[i].measure + '_rel'] = Helpers.formatNumberWithThousandSeparator(universeSizeValue).toString().replace('.', ',');
              let totalReachValue =
                response.summary[i].total_reach == -1 ? 'n/a' : Helpers.formatNumberWithThousandSeparator(Math.round(response.summary[i].total_reach)).toString().replace('.', ',');
              totalReach[response.summary[i].measure] = totalReachValue;
              totalReach[response.summary[i].measure + '_rel'] =
                response.data.slice(-1)[0].measuresRel[i] == -1
                  ? 'n/a'
                  : Helpers.formatNumberWithThousandSeparator(response.data.slice(-1)[0].measuresRel[i]).toString().replace('.', ',');
              let bigScreenReachValue = response.summary[i].big_screen_reach;
              if (bigScreenReachValue === -1) {
                bigScreenReachValue = 'n/a';
              } else {
                const parsedValue = parseFloat(bigScreenReachValue);
                if (isNaN(parsedValue) || parsedValue < 0) {
                  bigScreenReachValue = 'n/a';
                } else {
                  // Using French locale to format numbers with space as thousand separators
                  bigScreenReachValue = Math.round(parsedValue).toLocaleString('fr-FR');
                }
              }
              bigScreenReach[response.summary[i].measure] = bigScreenReachValue;
              bigScreenReach[response.summary[i].measure + '_rel'] =
                universeSizeValue && bigScreenReachValue === 'n/a'
                  ? 'n/a'
                  : ((parseInt(bigScreenReachValue.replace(/\s/g, ''), 10) / universeSizeValue * 100).toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }));

              let digitalDevicesReachValue = response.summary[i].digital_devices_reach;
              if (digitalDevicesReachValue === -1) {
                digitalDevicesReachValue = 'n/a';
              } else {
                const parsedValue = parseFloat(digitalDevicesReachValue);
                if (isNaN(parsedValue) || parsedValue < 0) {
                  digitalDevicesReachValue = 'n/a';
                } else {
                  // Using French locale to format numbers with space as thousand separators
                  digitalDevicesReachValue = Math.round(parsedValue).toLocaleString('fr-FR');
                }
              }
              digitalDevicesReach[response.summary[i].measure] = digitalDevicesReachValue;
              digitalDevicesReach[response.summary[i].measure + '_rel'] =
                universeSizeValue && digitalDevicesReachValue === 'n/a'
                  ? 'n/a'
                  : ((parseInt(digitalDevicesReachValue.replace(/\s/g, ''), 10) / universeSizeValue * 100).toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }));

              let averageFrequencyValue =
                response.summary[i].average_frequency == -1
                  ? 'n/a'
                  : response.summary[i].average_frequency;
              averageFreq[response.summary[i].measure] = averageFrequencyValue;
              averageFreq[response.summary[i].measure + '_rel'] = averageFrequencyValue;
              emptyRow[response.summary[i].measure] = '';
              emptyRow[response.summary[i].measure + '_rel'] = '';
            }

            context.commit('setItemsSite', [...context.getters.itemsSite, totalReach]);
            context.commit('setItemsSite', [...context.getters.itemsSite, averageFreq]);
            context.commit('setItemsSite', [...context.getters.itemsSite, universeSize]);
            context.commit('setItemsSite', [...context.getters.itemsSite, emptyRow]);
            context.commit('setItemsSite', [...context.getters.itemsSite, bigScreenReach]);
            context.commit('setItemsSite', [...context.getters.itemsSite, digitalDevicesReach]);
            context.commit('setItemsSite', [...context.getters.itemsSite, emptyRow]);

            const fieldsAbs = [...context.getters.fieldsAbsSite];
            const fieldsRel = [...context.getters.fieldsRelSite];
            for (let i = 0; i < response.data.length; i++) {
              for (let j = 0; j < fieldsAbs.length; j++) {
                if (fieldsAbs[j].key !== 'date_key') {
                  if (!response.data[i][fieldsAbs[j].key]) {
                    response.data[i][fieldsAbs[j].key] =
                      response.data[i].measures[j - 1] == -1
                        ? 'n/a'
                        : Helpers.formatNumberWithThousandSeparator(response.data[i].measures[j - 1]).toString().replace('.', ',')
                  }
                }
              }
              for (let j = 0; j < fieldsRel.length; j++) {
                if (fieldsRel[j].key !== 'date_key') {
                  if (!response.data[i][fieldsRel[j].key]) {
                    let measureRelValue = response.data[i].measuresRel[j - 1];
                    if (measureRelValue % 1 == 0) measureRelValue = measureRelValue.toFixed(1);
                    response.data[i][fieldsRel[j].key] =
                      measureRelValue == -1 ? 'n/a' : Helpers.formatNumberWithThousandSeparator(measureRelValue).toString().replace('.', ',');
                  }
                }
              }
            }
            context.commit('setFieldsAbsSite', fieldsAbs);
            context.commit('setItemsSite', [...context.getters.itemsSite, ...response.data]);
          }
          context.commit('setLoadingSite', false);
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.warn('Request canceled:', error.message); // Log cancellation
          } else {
            context.commit('setShowToastErrorSite', true);
            context.commit('setLoadingSite', false);
          }
        });
    },
  },
};
